var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.privacy)?_c('main',{staticClass:"m-privacy"},[_c('y-hero',{attrs:{"title":_vm.privacy.title,"synopsis":_vm.privacy.synopsis}}),_c('y-container',[_c('div',{staticClass:"m-privacy__content",domProps:{"innerHTML":_vm._s(_vm.privacy.text)}})]),_c('y-container',[_c('y-contact-banner',{attrs:{"items":_vm.privacy.custom}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }